import React from 'react';
import { useAuth } from '../../context/AuthContext';

const PermissionGuard = ({ 
  module, 
  action = 'view', 
  children, 
  fallback = null,
  requireAdmin = false 
}) => {
  const { user } = useAuth();

  if (!user) return fallback;

  // Admin bypass
  if (user.is_admin) return children;

  // Check admin requirement
  if (requireAdmin && !user.is_admin) return fallback;

  // Check module permission
  const modulePermissions = user.permissions?.[module];
  if (!modulePermissions) return fallback;

  const hasPermission = modulePermissions[action];
  if (!hasPermission) return fallback;

  return children;
};

// Hook version for more flexibility
export const usePermission = (module, action = 'view') => {
  const { user } = useAuth();

  if (!user) return false;
  if (user.is_admin) return true;

  const modulePermissions = user.permissions?.[module];
  if (!modulePermissions) return false;

  return !!modulePermissions[action];
};

// Check if user has any permission for a module
export const useModuleAccess = (module) => {
  const { user } = useAuth();

  if (!user) return false;
  if (user.is_admin) return true;

  const modulePermissions = user.permissions?.[module];
  if (!modulePermissions) return false;

  return Object.values(modulePermissions).some(Boolean);
};
export const useIsAdmin = () => {
  const { user } = useAuth();
  return !!user?.is_admin;
};

export default PermissionGuard;
